import angular from "../assets/images/angular.png";
import bootstrap from "../assets/images/bootstrap.png";
import exp from "../assets/images/exp.png";
import firebase from "../assets/images/firebase.png";
import js from "../assets/images/js.png";
import mongo from "../assets/images/mongo.png";
import mui from "../assets/images/mui.png";
import node from "../assets/images/node.png";
import react from "../assets/images/react.png";
import redux from "../assets/images/redux.png";
import tcss from "../assets/images/tcss.png";

export const skills = [
	//{ logo: html, name: "html" },
	//{ logo: css, name: "css" },
	{ logo: js, name: "javascript" },
	{ logo: react, name: "react" },
	{ logo: firebase, name: "firebase" },
	{ logo: mui, name: "material-ui" },
	{ logo: redux, name: "redux" },
	{ logo: bootstrap, name: "bootstrap" },
	{ logo: tcss, name: "tailwind-css" },
	//{ logo: ts, name: "typescript" },
	{ logo: angular, name: "angular" },
	{ logo: node, name: "node js" },
	{ logo: exp, name: "express js" },
	{ logo: mongo, name: "mongo db" },
];
